import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=00bb6886"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=00bb6886&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00bb6886')) {
      api.createRecord('00bb6886', component.options)
    } else {
      api.reload('00bb6886', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=00bb6886", function () {
      api.rerender('00bb6886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrintSuite/Settings.vue"
export default component.exports